module.exports = __webpack_public_path__ + "media/categories/5009-deb9b039.svg";